import * as React from 'react'
import PT from 'prop-types'
import { CircularProgress } from 'material-ui'
import Card from '@vimcar/shared-components/components/Card'
import CardHeader from '@vimcar/shared-components/components/CardHeader'
import CardContent from '@vimcar/shared-components/components/CardContent'
import linkViewModel from '@vimcar/shared-utils/linkViewModel'

import Err from '#components/Err'
import colors from '#styles/colors'
import i18n from '#utils/i18n'
import DefaultViewPreferences from './components/DefaultViewPreferences'
import LanguagePreferences from './components/LanguagePreferences'
import NotificationsPreferences from './components/NotificationsPreferences'
import TimezonePreferences from './components/TimezonePreferences'
import mkViewModel from './viewModel'
import styles from './styles.css'

const tp = i18n.prefix('components.ProfilePreferences')

const ProfilePreferences = ({ viewModel, loading }) => (
  <Card>
    <CardHeader
      style={headerStyle}
      title={tp('settings')}
      >
      {(viewModel.initializing || loading) && (
        <CircularProgress
          color={colors.colorPrimary}
          size={20}
          style={spinnerStyle}
          />
      )}
    </CardHeader>
    <CardContent>
      {viewModel.error && <Err>{viewModel.error}</Err>}
      {!viewModel.initializing && (
        <React.Fragment>
          <DefaultViewPreferences
            className={styles.section}
            disabled={loading}
            titleClassName={styles.sectionTitle}
            updateUserPreferences={viewModel.updateUserPreferences}
            />
          <LanguagePreferences
            className={styles.section}
            titleClassName={styles.sectionTitle}
            />
          <TimezonePreferences
            className={styles.section}
            disabled={loading}
            titleClassName={styles.sectionTitle}
            />
          <NotificationsPreferences
            className={styles.section}
            disabled={loading}
            onRequest={viewModel.handleRequest}
            titleClassName={styles.sectionTitle}
            />
        </React.Fragment>
      )}
    </CardContent>
  </Card>
)

const headerStyle = {
  display: 'flex',
  justifyContent: 'flex-start',
}
const spinnerStyle = {
  margin: 5,
}

ProfilePreferences.propTypes = {
  loading: PT.bool,
  viewModel: PT.object,
}

export default linkViewModel(mkViewModel, ProfilePreferences)
